/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { AsyncResult, IActionContext } from '@msdyn365-commerce/core';

import { BaseCheckoutState } from '../checkout-state/base-checkout-state';
import { ICheckoutState } from '../state-interfaces/i-checkout-state';
import checkoutStateDataAction from './checkout-state-data-action';
import { GlobalStateInput } from './global-state-data-action';

export function getCheckoutState(ctx: IActionContext): AsyncResult<ICheckoutState> {
    return checkoutStateDataAction(
        new GlobalStateInput<ICheckoutState>('CHECKOUTSTATE', BaseCheckoutState, ctx.requestContext.apiSettings, ctx.requestContext),
        ctx
    );
}
